export default {"src":"/_next/static/media/free-shipping.ffe193ee.svg","height":62,"width":60,"blurWidth":0,"blurHeight":0};